export default {
  allowBePromoted: "allowBePromoted",
  allowReceiveBirthdayMessages: "allowReceiveBirthdayMessages",
  allowReceiveMassLetterMessage: "allowReceiveMassLetterMessage",
  allowReceivePromotionsMessages: "allowReceivePromotionsMessages",
  allowSendMassLetterMessage: "allowSendMassLetterMessage",
};
